// Gallery.jsx
import React, { useState } from 'react';
import { gallery } from '../images/gallery/gallery';
import { Modal } from 'react-bootstrap';
import '../scss/Gallery.scss';

function Gallery() {
    const [show, setShow] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);

    const handleShow = () => setShow(true);

    const imgClickHandler = (src) => {
        setImgSrc(src);
        handleShow();
    }

    return (
        <div className='paddingStyle'>
            <section className='gallery-section'>
                <div className='gallery-header'>
                    <h1 className='gallery-title'>Gallery</h1>
                    <p className='gallery-subtitle'>Explore our moments and memories</p>
                </div>

                <div className='galleryContainer'>
                    <Modal
                        show={show}
                        onHide={() => setShow(false)}
                        dialogClassName="modal-90w"
                        centered
                    >
                        <Modal.Header closeButton className="modal-custom-header">
                        </Modal.Header>
                        <Modal.Body className="modal-custom-body">
                            <img 
                                src={imgSrc} 
                                className="modal-image" 
                                alt="Gallery" 
                            />
                        </Modal.Body>
                    </Modal>

                    <div className='imgContainer'>
                        {gallery.map((img, index) => {
                            return (
                                <div 
                                    key={index} 
                                    className='gallery-item'
                                    onClick={() => imgClickHandler(img)}
                                >
                                    <img 
                                        src={img} 
                                        alt={`Gallery ${index + 1}`} 
                                        className="gallery-image"
                                    />
                                    <div className='gallery-overlay'>
                                        <svg 
                                            className="zoom-icon" 
                                            viewBox="0 0 24 24" 
                                            fill="none" 
                                            stroke="currentColor"
                                        >
                                            <circle cx="11" cy="11" r="8"/>
                                            <path d="m21 21-4.35-4.35"/>
                                            <line x1="11" y1="8" x2="11" y2="14"/>
                                            <line x1="8" y1="11" x2="14" y2="11"/>
                                        </svg>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Gallery;